import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html } from '../../common'

$(init)

async function init () {
  let $page = $('#active-plans-page')
  if ($page.length == 0) {
    return
  }
  try {
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let premium_plans = (await get_json(`/premium/get-my-premium-plans`)).data
    $page.find('.loading-indicator').addClass('d-none')
    if (premium_plans.length == 0) {
      $page.find('.premium-plans-empty').removeClass('d-none')
    } else {
      let $plans = $page.find('.premium-plans')
      $plans.removeClass('d-none')
      $plans.html('')
      for (let premium_plan of premium_plans) {
        premium_plan.created_at_text = (new Date(parseInt(premium_plan.created_at) * 1000))+''
        $plans.append(eval_html_template('#premium-listings-template', premium_plan))
      }
    }
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}
